// extracted by mini-css-extract-plugin
module.exports = {"container":"NewDonor_container__1jJl9","contact":"NewDonor_contact__3BTDH"};